import { useState, useCallback } from 'react'

/**
 * カードフォームの状態管理hook
 * フォームデータ、バリデーション状態、変更ハンドラーを提供
 */
export const useCardFormState = () => {
  // フォームデータ
  const [formData, setFormData] = useState({
    cardNumber: '',
    expiryMonth: '',
    expiryYear: '',
    cardHolder: '',
    securityCode: '',
  })

  // 各フィールドのバリデーション状態
  const [validationState, setValidationState] = useState({
    cardNumber: false,
    expiry: false,
    cardHolder: false,
    securityCode: false,
  })

  // 全フィールドが有効かつ入力済みか
  const isFormComplete = validationState.cardNumber && validationState.expiry && validationState.cardHolder && validationState.securityCode

  // CardNumberの変更ハンドラー
  const handleCardNumberChange = useCallback((value, isValid) => {
    setFormData((prev) => ({ ...prev, cardNumber: value }))
    setValidationState((prev) => ({ ...prev, cardNumber: isValid }))
  }, [])

  // Expiryの変更ハンドラー
  const handleExpiryChange = useCallback((expiry, isValid) => {
    setFormData((prev) => ({ ...prev, expiryMonth: expiry.month, expiryYear: expiry.year }))
    setValidationState((prev) => ({ ...prev, expiry: isValid }))
  }, [])

  // CardHolderの変更ハンドラー
  const handleCardHolderChange = useCallback((value, isValid) => {
    setFormData((prev) => ({ ...prev, cardHolder: value }))
    setValidationState((prev) => ({ ...prev, cardHolder: isValid }))
  }, [])

  // SecurityCodeの変更ハンドラー
  const handleSecurityCodeChange = useCallback((value, isValid) => {
    setFormData((prev) => ({ ...prev, securityCode: value }))
    setValidationState((prev) => ({ ...prev, securityCode: isValid }))
  }, [])

  return {
    formData,
    isFormComplete,
    handlers: {
      handleCardNumberChange,
      handleExpiryChange,
      handleCardHolderChange,
      handleSecurityCodeChange,
    },
  }
}
